import React from 'react';
import { createRoot } from 'react-dom/client';
import ExtraCardSign from './components/extra-card-sign.jsx';

jQuery(function ($) {
    $('#apply_extra_card').validate({
        rules: {
            extra_personal_number: {
                required: true,
                isValidSwedishSSN: true,
                number: true
            },
            extra_first_name: "required",
            extra_last_name: "required",
            extra_email: {
                required: true,
                email: true
            },
            extra_phone_number: {
                required: true,
                validPhoneNumber: "SE",
            }
        },
        messages: {
            extra_personal_number: {
                required: "Ange extrakortsökandens personnummer 12 siffror",
                isValidSwedishSSN: "Kontrollera personnumret (12 siffror)",
                number: "Ange endast siffror",
            },
            extra_first_name: "Ange extrakortsökandens förnamn",
            extra_last_name: "Ange extrakortsökandens efternamn",
            extra_email: {
                required: "Ange extrakortsökandens e-postadress",
                email: "Ange en giltig e-postadress"
            },
            extra_phone_number: {
                required: "Ange extrakortsökandens telefonnummer",
                validPhoneNumber: "Ange ett giltigt telefonnummer"
            }
        },
        submitHandler: function (form, e) {
            sendExtraCardApplication(form, e);
        }
    });

    function sendExtraCardApplication(form, event) {
        event.preventDefault();
        $('.application-loader').removeClass('hidden');

        var form_data = $(form).serializeArray().reduce(function (obj, item) {
            obj[item.name] = item.value;
            return obj;
        }, {});

        var data = {
            action: 'cgi_apply_extra',
            security: CGIAjax.security,
            extra_personal_number: form_data.extra_personal_number,
            extra_first_name: form_data.extra_first_name,
            extra_last_name: form_data.extra_last_name,
            extra_email: form_data.extra_email,
            extra_phone_number: form_data.extra_phone_number,
        };

        $('.application-loader').removeClass('hidden');
        $('#apply_extra_card .cgi-message').html('').hide();

        $.post(CGIAjax.ajaxurl, data, function (res) {
            try {
                var response = jQuery.parseJSON(res);
            }
            catch {
                $('#apply_extra_card .cgi-message').html('Ett oväntat fel har uppstått. Vänligen försök igen eller kontakta kundtjänst om felet återkommer.').show();
                $('.application-loader').addClass('hidden');
                $('.application-loader-header').html('Signering startar...');
                $('.application-loader-instructions').html('<a class="cgi-abort-sign" href="#">Avbryt</a>');
                return;
            }

            if (response.status == 'ok') {
                if (response.data.preliminary_decision == 'Approved') {
                    window.location.assign(`${CGIExtraAjax.extraCard}signera-huvudkort`);
                } else {
                    window.location.assign(`${CGIExtraAjax.extraCard}avslag`);
                }
            } else {
                try {
                    if (typeof response.error[0].message !== 'undefined') {
                        $('#apply_extra_card .cgi-message').html(response.error[0].message).show();
                    } else if (typeof response.error !== 'undefined') {
                        $('#apply_extra_card .cgi-message').html(response.error).show();
                    } else {
                        $('#apply_extra_card .cgi-message').html('Ett oväntat fel har uppstått. Vänligen försök igen eller kontakta kundtjänst om felet återkommer.').show();
                    }
                } catch {
                    $('#apply_extra_card .cgi-message').html('Ett oväntat fel har uppstått. Vänligen försök igen eller kontakta kundtjänst om felet återkommer.').show();
                }
                $('.application-loader').addClass('hidden');
                $('.application-loader-header').html('Signering startar...');
                $('.application-loader-instructions').html('<a class="cgi-abort-sign" href="#">Avbryt</a>');
            }
        });
    }

    let extraCardStatusPoll = $('#extra-card-status-poll');

    if (extraCardStatusPoll.length) {
        let applicationId = extraCardStatusPoll.data('application-id');
        let steps = extraCardStatusPoll.data('steps');

        async function getExtraCardDecision(applicationId) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: CGIAjax.ajaxurl,
                    data: {
                        action: 'extra_card_decision',
                        application_id: applicationId,
                        security: CGIAjax.security,
                    },
                    success: function (response) {
                        if (!response.success) {
                            return reject();
                        }
                        resolve(response.data.decision);
                    },
                    error: function () {
                        reject();
                    }
                });
            });
        }

        async function pollExtraCardStatus(remainingSteps) {
            if (remainingSteps <= 0){
                $('.cgi-progress-text').html('<h2>Manuell behandling</h2><p>Din ansökan kräver manuell behandling. Du kommer få besked per SMS så fort den är färdighanterad.</p>');
                return;
            };

            try {
                let status = await getExtraCardDecision(applicationId);

                $('.cgi-progress-bar').width(`${(steps - remainingSteps + 2) / steps * 100}%`);

                switch (status) {
                    case 'Granted':
                        $('.cgi-progress-text').html('<h2>Ansökan godkänd</h2><p>Ditt kort kommer hem i din brevlåda om ca. 1 vecka. Hoppas att du ska få mycket glädje av ditt nya kort!</p>');
                        break;
                    case 'Denied':
                        $('.cgi-progress-text').html('<h2>Ansökan nekad</h2><p>Beslutet är fattat efter att en kreditprövning gjorts. Detta är en helhetsbedömning där vi bland annat tagit hänsyn till din inkomst, befintlig skuld, antal kreditförfrågningar samt eventuella betalningsanmärkningar.</p>');
                        break;
                    case 'Pending':
                        setTimeout(function () {
                            pollExtraCardStatus(remainingSteps - 1);
                        }, 1000);
                        break;
                }
            } catch {
                $('.cgi-progress-text').html('<h2>Något har gått fel</h2><p>Vi upplever problem när vi hämtar status på din ansökan. Vänligen kontakta kundtjänst du inte fått besked per SMS inom kort.</p>');
            }
        }

        pollExtraCardStatus(steps);
    }

});

document.addEventListener('DOMContentLoaded', () => {
    const signOwnerDiv = document.getElementById('extra-sign-owner');
    const signOwnerSignee = document.getElementById('extra-sign-signee');

    if (signOwnerDiv) {
        const root = createRoot(signOwnerDiv);
        const urlParams = new URLSearchParams(window.location.search);
        const transactionId = urlParams.get('transactionId');

        root.render(
            <div className="cgi-login-form-wrapper application-loader-wrapper">
                <div className="cgi-login-form">
                    <ExtraCardSign transaction={transactionId || ''} signer='owner' />
                </div>
            </div>
        );
    }

    if (signOwnerSignee) {
        const root = createRoot(signOwnerSignee);
        const urlParams = new URLSearchParams(window.location.search);
        const transactionId = urlParams.get('transactionId');

        root.render(
            <div className="cgi-login-form-wrapper application-loader-wrapper">
                <div className="cgi-login-form">
                    <ExtraCardSign transaction={transactionId || ''} signer='signee' />
                </div>
            </div>
        );
    }
});
